// hover.js
var Hover = pc.createScript('hover');

Hover.attributes.add('identyfier', {type:'boolean', default:false});
Hover.attributes.add('toolTip', {type:'entity'});
Hover.attributes.add('fwa', {type:'entity'});

// initialize code called once per entity
Hover.prototype.initialize = function() {
    this.entity.element.on('mouseenter', this.onEnter, this);
    this.entity.element.on('mouseleave', this.onLeave, this);
    this.entity.element.on('click', this.up, this);
    this.cam = this.app.root.findByName('Camera');
    this.camScript = this.cam.script.orbitCamera;
    this.firstTime = true;
};

// update code called every frame
Hover.prototype.onEnter = function () {
    
    if(this.toolTip !== null){
        // console.info(this.toolTip.parent);
        // console.info(this.entity);
        var pos = this.entity.getPosition();
        this.toolTip.parent.setPosition(pos.x, pos.y+0.06, pos.z);
        this.toolTip.enabled = true;
    }

    if(this.entity.name == 'twitter'){
        return;
    }
    
    if(this.entity.name == 'burger'){
        return;
    }

    if(this.entity.tags.has('buttonAdUI')){
        return;
    }
    
    if(this.entity.name == 'generateButton'){
        return;
    }
    
    this.app.fire('userInput:objectHovered', this.entity);
};

Hover.prototype.onLeave = function () {
        
    if(this.toolTip !== null){
        this.toolTip.enabled = false;
    }

    if(this.entity.name == 'twitter'){
        return;
    }
    if(this.entity.name == 'burger'){
        return;
    }
    if(this.entity.tags.has('buttonAdUI')){
        return;
    }
    
    if(this.entity.name == 'generateButton'){
        return;
    }
    
    this.app.fire('userInput:objectUnHovered', this.entity);
};

Hover.prototype.up = function () {
    
    if(this.entity.name == 'twitter' && this.entity.button.active == true){
        this.app.fire('ui:takeScreenshot');
        return;
    }
    
    if(this.entity.name == 'twitter' && this.entity.button.active == false){
        return;
    }
    
    if(this.entity.name == 'burger'){
        this.app.fire('userInput:burger');
        return;
    }
    if(this.entity.tags.has('buttonAdUI')){
        //this.app.fire('uiGenerator:collectorGenerator:turnOff');
        this.app.fire('hoverClick:clicked', this.entity);
        return;
    }
    if(this.entity.name == 'generateButton'){
        
        this.app.fire('hover:generatorTrigger');
        if(!this.firstTime){
            var ps = new pc.Vec3(0,0,0);
            this.camScript.distanceMin = 1000;
            this.camScript.distanceMax = 2500;
            this.camScript.resetAndLookAtPoint(this.cam.getLocalPosition(), ps, true);
        }
        this.fwa.element.enabled = false;
        this.firstTime = false;
        return;
    }
    if(this.entity.parent.name !== 'system'){
        this.app.fire('userInput:objectSelected', this.entity.parent.script.planetTagger.target);
    } else {
        this.app.fire('userInput:objectSelected', this.entity.parent.script.planetTagger.target);
    }

};




// swap method called for script hot-reloading
// inherit your script state here
// Hover.prototype.swap = function(old) { };

// to learn more about script anatomy, please read:
// http://developer.playcanvas.com/en/user-manual/scripting/

